import React from "react";
import PropTypes from "prop-types";
import ReportProblemBlackIcon from "./report_problem_black_24dp.svg?react";
import ReportProblemWhiteIcon from "./report_problem_white_24dp.svg?react";

export default function ReportProblemIcon(props) {
	return <div>{props.white ? <ReportProblemWhiteIcon /> : <ReportProblemBlackIcon />}</div>;
}

ReportProblemIcon.propTypes = {
	white: PropTypes.bool,
};
